import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';
import COMMON_EN from './common/locale/en';
import PHOTOS_PAGE_EN from './photos/locale/en';

export const resources = {
  en: { common: COMMON_EN, photosPage: PHOTOS_PAGE_EN },
};

export const ns = ['common', 'accountPage', 'photosPage'];

export const defaultNS = 'common';

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const i18n = () =>
  i18next
    // eslint-disable-next-line max-len
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // eslint-disable-next-line max-len
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    // .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      fallbackLng: 'en',
      debug: true,

      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      ns,
      defaultNS,
      resources,
    });

export default i18n;
